import { useState } from "react";
import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Typography,
  Button,
} from "@mui/material";
import {
  MdAddCircle,
  MdRemoveCircle,
  MdCall,
  MdConfirmationNumber,
} from "react-icons/md";
export const PassengerCard = ({ trip, onCardClick }) => {
  const [expanded, setExpanded] = useState(false);

  const {
    PNRNo,
    FromCityShortName,
    ToCityShortName,
    PickupManName,
    SeatNos,
    TotalFare,
    passengers,
    PassengerContactNo1,
    CustomerName,
  } = trip;
  const toggleExpand = (e) => {
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };

  return (
    <Box
      onClick={onCardClick}
      sx={{
        p: 2,
        cursor: "pointer",
        lineHeight: 1,
        borderBottom: "1px solid rgba(0, 0, 0, 0.15)",
      }}
    >
      <Box display="flex" justifyContent="space-between">
        <Box
          fontWeight={500}
          display="flex"
          alignItems="center"
          gap={1}
          color="text.secondary"
        >
          <MdConfirmationNumber size={20} color="icon.primary" />
          {PNRNo}
        </Box>
        <Box fontWeight={500}>
          {FromCityShortName}-{ToCityShortName}
        </Box>
      </Box>

      <Box color="text.primary" fontWeight={500} mt={1}>
        Pickup: {PickupManName}
      </Box>
      <Box
        sx={{
          borderRadius: 2,
          overflow: "hidden",
          border: "1px solid #e0e0e0",
          marginTop: "8px",
        }}
      >
        <Table
          size="small"
          mt={1}
          sx={{
            "& .MuiTableCell-root": {
              padding: "4px 2px",
            },
            lineHeight: 1,
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: "table.headBackground" }}>
              <TableCell style={{ paddingLeft: "8px" }}>Seat No.</TableCell>
              <TableCell>Primary Name</TableCell>
              <TableCell align="right">Total Fare</TableCell>
              <TableCell width={30} />
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell style={{ paddingLeft: "8px" }}>{SeatNos}</TableCell>
              <TableCell>
                <Button
                  startIcon={<MdCall />}
                  onClick={(e) => {
                    e.stopPropagation();
                    window.location.href = `tel:${PassengerContactNo1}`;
                  }}
                  disabled={!PassengerContactNo1}
                  color="primary"
                  variant="text"
                  size="small"
                  sx={{
                    padding: 0,
                    minWidth: "auto",
                    textTransform: "none",
                  }}
                >
                  <Typography sx={{ color: "text.primary" }}>
                    {CustomerName}
                  </Typography>
                </Button>
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 600 }}>
                {TotalFare}
              </TableCell>
              <TableCell style={{ padding: 0 }}>
                <IconButton size="small" onClick={toggleExpand} color="primary">
                  {expanded ? (
                    <MdRemoveCircle size={24} />
                  ) : (
                    <MdAddCircle size={24} />
                  )}
                </IconButton>
              </TableCell>
            </TableRow>

            {expanded &&
              passengers.map((p, idx) => (
                <TableRow
                  key={idx}
                  sx={{ backgroundColor: "table.headBackground" }}
                >
                  <TableCell
                    style={{ paddingLeft: "8px" }}
                    sx={{ fontWeight: 500 }}
                  >
                    {p.SeatNoWithGender}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>{p.PaxName}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 500 }}>
                    {p.SeatwiseFare}
                  </TableCell>
                  <TableCell />
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};
